module.exports = __webpack_public_path__ + "img/649.38ef7cb7.jpg";